import { useEffect, useState, useRef } from "react";
import * as Scrivito from "scrivito";

import { DesktopNav, MobileNav, get } from "./Navigation";

const getContainer = (element) =>
  element.closest("section") || element.closest(".content-wrapper");

export const InpageNavigationWidget = Scrivito.connect(
  ({ widget, options }) => {
    const [isTablet, setIsTablet] = useState(false);
    const direction = get(widget, options, "direction", "horizontal");
    const largeTopMargin = get(widget, options, "largeTopMargin", false);
    const navRef = useRef(null);

    useEffect(() => {
      if (!navRef.current) return;

      const nav = navRef.current;
      const container = getContainer(nav);

      if (!container) return;

      const updateOffset = () => {
        const height = nav.offsetHeight;
        container.style.setProperty("--sticky-offset", `${height}px`);
      };

      updateOffset();

      if (typeof window.ResizeObserver !== "undefined") {
        const observer = new window.ResizeObserver(updateOffset);
        observer.observe(nav);
        return () => observer.disconnect();
      }
    }, []);

    useEffect(() => {
      const update = () => {
        setIsTablet(window.innerWidth < 769);
      };

      update();

      if (typeof window.ResizeObserver !== "undefined") {
        const observer = new window.ResizeObserver(update);
        observer.observe(document.documentElement);
        return () => observer.disconnect();
      }
    }, []);

    return (
      <nav
        ref={navRef}
        className={`inpage-navigation-widget --${direction}
          ${largeTopMargin ? "--large-top-margin" : "--default-top-margin"}
        `}
        role="navigation"
        aria-label="Inpage Navigation"
      >
        {isTablet ? (
          <MobileNav widget={widget} options={options} />
        ) : (
          <DesktopNav widget={widget} options={options} />
        )}
      </nav>
    );
  }
);

const InpageNavigationWidgetWrapper = Scrivito.connect(({ widget }) => {
  const sticky = get(widget, {}, "sticky", false);
  return (
    <Scrivito.WidgetTag
      className={`
      ${sticky ? "sticky-top" : "sticky-none"}
    `}
    >
      <InpageNavigationWidget widget={widget} />
    </Scrivito.WidgetTag>
  );
});

Scrivito.provideComponent(
  "InpageNavigationWidget",
  InpageNavigationWidgetWrapper
);
